import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import data from "../preloaded/deep_pyramid.json";
import { useTranslation } from "react-i18next";

// Format data for the chart (handle missing values)
const formattedData = data.map(({ level, users_registered, scammers = 0, scammed_people = 0 }) => ({
  level,
  registered: users_registered - scammers - scammed_people, // Legitimate users
  scammers,
  scammed_people,
}));

export const PyramidChart = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center bg-gray-100">
      <div className="w-full bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold text-center mb-4">{t('pyramid_title')}</h2>
        <p>{t('info_deep')}</p>

        <ResponsiveContainer width="100%" height={600}>
          <BarChart layout="vertical" data={formattedData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="level" type="category" width={50} />
            <Tooltip
              formatter={(value, name) => [value, name]}
              labelFormatter={(label) => `${t('pyramid_deep')}: ${label}`}
            />
            <Legend />
            <Bar dataKey="registered" stackId="users" fill="#1D4ED8" name={t('inactive')} />
            <Bar dataKey="scammed_people" stackId="users" fill="#f59e0b" name={t('scammed')} />
            <Bar dataKey="scammers" stackId="users" fill="#ef4444" name={t('scammers')} />

          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
